/*
 * Copyright (C) 2020 Reciprocity, Inc - All Rights Reserved
 * Unauthorized use, copying, distribution, displaying, or public performance
 * of this file, via any medium, is strictly prohibited. All information
 * contained herein is proprietary and confidential and may not be shared
 * with any third party without the express written consent of Reciprocity, Inc.
 */

import { UserRole } from '@/constants/Users';

export const gqlGroupFilter = (searchValue: string) => ({
  left: 'title',
  op: {
    name: '~',
  },
  right: searchValue,
});

export const gqlPersonFilterByNameOrEmail = (searchValue: string) => ({
  left: {
    left: 'name',
    op: {
      name: '~',
    },
    right: searchValue,
  },
  op: {
    name: 'OR',
  },
  right: {
    left: 'email',
    op: {
      name: '~',
    },
    right: searchValue,
  },
});

export const personDropdownOptionsQueryFilter = (searchValue: string = ''): string => {
  const filteredByRoles = {
    left: 'user_role',
    op: {
      name: 'in_array',
    },
    right: [UserRole.Administrator, UserRole.Editor, UserRole.Contributor, UserRole.Reader],
  };
  return searchValue
    ? JSON.stringify({
        left: filteredByRoles,
        op: {
          name: 'AND',
        },
        right: gqlPersonFilterByNameOrEmail(searchValue),
      })
    : JSON.stringify(filteredByRoles);
};

export const groupDropdownOptionsQueryFilter = (searchValue: string = ''): string => {
  const filter = searchValue ? gqlGroupFilter(searchValue) : [];

  return JSON.stringify(filter);
};
